module.exports={
  "Read more": "LÃ¦s mere"
}
